import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Edit Settings
    </span>
  );
};
